import {
  Dialog,
  DialogActions,
  List,
  ListItem,
  ListItemText,
  Typography,
} from "@mui/material";

const LotOverlapModal = ({
  showLotOverlapModal,
  setShowLotOverlapModal,
  data,
}) => {
  return (
    <Dialog
      open={showLotOverlapModal}
      onClose={() => setShowLotOverlapModal(false)}
    >
      <div
        style={{
          width: "400px",
          padding: "20px",
        }}
      >
        <Typography id="modal-modal-title" variant="h6" component="h2">
          Exceed Available Quantity
        </Typography>
        <Typography id="modal-modal-description" sx={{ mt: 2, mb: 1 }}>
          The following items exceed available quantity:
        </Typography>

        <List dense>
          {data.map((item, index) => {
            const [drugName, details] = item.split(" ("); // split into 2 parts
            return (
              <ListItem key={index} sx={{ py: 0 }}>
                <ListItemText
                  primary={
                    <>
                      <Typography component="span" fontWeight="bold">
                        {drugName}
                      </Typography>
                      {details ? ` (${details}` : ""}
                    </>
                  }
                />
              </ListItem>
            );
          })}
        </List>
      </div>
      <DialogActions>
        <button
          className="create-btn-outlined"
          style={{ width: "120px" }}
          onClick={() => {
            setShowLotOverlapModal(false);
          }}
        >
          Close
        </button>
      </DialogActions>
    </Dialog>
  );
};

export default LotOverlapModal;
